// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"96036a4d","239":"4c2ac08d","453":"09b2f3c8","455":"91edea90"}[chunkId] + ".chunk.js";
};